import { useState } from "react";
import { useTranslation } from "react-i18next";
import FormBlock from "../../../Components/Inputs/FormBlock";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import instance from "../../../Interceptor/api_instance";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import { ActionResponse } from "../../../Components/Modals/ActionResponses";

/**
 * NewSeal – modal form to create a new seal record.
 * @param {Function} onSuccess - called after a successful creation so the parent can refresh data.
 * @param {Function} close - closes the modal.
 */
const NewSeal = ({ onSuccess, close }) => {
  const { t } = useTranslation();
  const [sealNumber, setSealNumber] = useState("");

  // Mutation hook: handles loading / error state for the POST request
  const {
    mutate: createSeal,
    isLoading,
    error,
    setError,
  } = useApiMutation(async (payload, { signal }) => {
    const res = await instance.post(`safety/seals/`, payload, { signal });
    return res;
  });

  // Submit handler: creates the seal, then notifies parent and closes on success
  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await createSeal({ seal_number: sealNumber });
    // res is undefined when the request was aborted or caught an error
    if (res?.status === 201) {
      onSuccess();
      close();
    }
  };

  return (
    <div className="page-mask page-mask-animation">
      {/* Display API error as a dismissible banner */}
      {error && <ActionResponse message={error} close={() => setError(null)} />}
      <div className="edit-modal">
        <h2>{t("general.newSeal")}</h2>
        <form onSubmit={handleSubmit}>
          <FormBlock
            label={t("forms.type.vehicle.labels.sealNumber")}
            name={"sealNumber"}
            isRequired={true}
            update={(e) => setSealNumber(e.target.value)}
            placeholder={t("yard-tables.table-columns.seal")}
          />
          <div className="full-cont">
            {isLoading ? (
              <Spinner />
            ) : (
              <>
                <button type="submit" className="change-pwd-btn">
                  {t("buttons.submit")}
                </button>
                <button
                  type="button"
                  className="all-btn cancel-btn"
                  onClick={close}
                >
                  {t("buttons.cancel")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewSeal;
